import { CreateAnalysisDataCriteria } from 'use-case/analysis/analysisCriteria';
import Analysis, { PARENT_ANALYSIS_TYPE } from 'domain/entity/analysis';
import { getApiClient } from 'adapter/out/client/apiClient';
import { parseAnalysisDataCriteria } from 'adapter/out/client/analysis/parseAnalysis';

const createAnalysisApiClient = getApiClient(
    (clientCriteria: CreateAnalysisDataCriteria) =>
        `dashboards/${parseParentType(clientCriteria.parentType)}/${clientCriteria.parentId}/analyses`,

    Analysis,
    (clientCriteria: CreateAnalysisDataCriteria) => ({
        method: 'POST',
        body: JSON.stringify(parseAnalysisDataCriteria(clientCriteria)),
        headers: { 'Content-Type': 'application/json' },
    })
);

const parseParentType = (parentType: PARENT_ANALYSIS_TYPE) =>
    parentType === PARENT_ANALYSIS_TYPE.DASHBOARD_ANALYSIS ? 'dashboards' : 'stored-analyses';

export default createAnalysisApiClient;
